import { render, staticRenderFns } from "./PayrollChangeRequestDetailFormDialog.vue?vue&type=template&id=809848fc&"
import script from "./PayrollChangeRequestDetailFormDialog.vue?vue&type=script&lang=ts&"
export * from "./PayrollChangeRequestDetailFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports